import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import { getDate, isPast, isSameDay, isSameMonth, startOfDay } from 'date-fns'

type Props = {
  currentDate: Date
  date: Date
  handleCurrentDate: (date: Date) => void
  isActive: boolean
  isClosed: boolean
  isSpecialHoliday: boolean
}

const StockCalendarCell: FC<Props> = React.memo((props) => {
  const { currentDate, date, handleCurrentDate, isActive, isClosed, isSpecialHoliday } = props

  const isThisMonth = isSameMonth(date, currentDate)

  const className = (() => {
    switch (true) {
      // 表示日以前
      case isPast(startOfDay(date)):
        return styles.table__cell_disabled
      // 選択状態
      case isThisMonth && isActive:
        return styles.table__cell_active
      // 休業日・臨時休業日が祝日
      case isThisMonth && isClosed && isSpecialHoliday:
        return styles.table__cell__holiday_disabled
      // 休業日・臨時休業日
      case isThisMonth && isClosed:
        return styles.table__cell_disabled
      // 表示日が祝日
      case isThisMonth && isSameDay(date, new Date()) && isSpecialHoliday:
        return styles.table__cell__holiday_today
      // 当日が祝日
      case isThisMonth && isSameDay(date, new Date()):
        return styles.table__cell_today
      case isThisMonth && isSpecialHoliday:
        return styles.table__cell__holiday
      default:
        return styles.table__cell
    }
  })()

  const onClickDate = () => {
    const disabled = isPast(startOfDay(date)) || !isThisMonth || isClosed
    if (disabled) {
      return null
    } else {
      handleCurrentDate(date)
    }
  }

  return (
    <td className={className} onClick={onClickDate}>
      <span className={styles.table__cell__date}>{isThisMonth ? getDate(date) : ''}</span>
    </td>
  )
})

export default StockCalendarCell
